<template>
  <div class="payment-channel">
    <div class="channel-title">选择支付方式</div>
    <div class="channel-list">
      <div 
        v-for="channel in availableChannels" 
        :key="channel.id"
        class="channel-item"
        :class="{ 'disabled': !channel.isOn, 'selected': selectedChannel && selectedChannel.id === channel.id }"
        @click="selectChannel(channel)"
      >
        <div class="channel-icon">
          <van-icon :name="getChannelIcon(channel.payType)" :size="24" />
        </div>
        <div class="channel-info">
          <div class="channel-name">{{ channel.channelName }}</div>
          <div class="channel-desc">{{ channel.channelDesc || '安全便捷的支付方式' }}</div>
        </div>
        <div class="channel-status">
          <van-icon v-if="!channel.isOn" name="warning-o" color="#ff6b6b" />
          <van-icon v-else-if="selectedChannel && selectedChannel.id === channel.id" name="success" color="#07c160" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted, getCurrentInstance } from 'vue'
import { Icon } from 'vant'
export default {
  name: 'PaymentChannel',
  components: {
    [Icon.name]: Icon
  },
  props: {
    brandId: {
      type: String,
      required: true
    },
    modelValue: {
      type: Object,
      default: null
    }
  },
  emits: ['update:modelValue', 'channel-change'],
  setup(props, { emit }) {
    const { proxy } = getCurrentInstance()
    const channels = ref([])
    const selectedChannel = ref(props.modelValue)
    const loading = ref(false)

    // 固定展示的渠道ID
    const fixedChannelIds = [1, 11, 13, 14]

    // 需要排除的渠道名称关键词
    const excludeKeywords = ['兑换', '余额退款', '支付宝提现']
    
    // 计算可用的支付渠道
    const availableChannels = computed(() => {
      return channels.value.filter(channel => {
        // 检查是否在固定展示的渠道中
        const isInFixedChannels = fixedChannelIds.includes(channel.payType)
        
        // 检查是否包含需要排除的关键词
        const shouldExclude = excludeKeywords.some(keyword => 
          channel.channelName && channel.channelName.includes(keyword)
        )
        
        return isInFixedChannels && !shouldExclude
      })
    })

    // 获取支付渠道列表
    const getChannels = async () => {
      try {
        loading.value = true
        const res = await proxy.$http.brandApi.getChannel(1, {
          brandId: props.brandId
        })
        
        if (res.success) {
          channels.value = res.data.content || []
          console.log('获取到的所有渠道:', channels.value)
          console.log('过滤后的可用渠道:', availableChannels.value)
        }
      } catch (error) {
        console.error('获取支付渠道失败:', error)
        proxy.$toast('获取支付渠道失败')
      } finally {
        loading.value = false
      }
    }

    // 选择支付渠道
    const selectChannel = (channel) => {
      if (!channel.isOn) {
        proxy.$toast('该支付渠道暂未开放')
        return
      }
      
      selectedChannel.value = channel
      emit('update:modelValue', channel)
      emit('channel-change', channel)
    }

    // 获取渠道图标
    const getChannelIcon = (payType) => {
      const iconMap = {
        'alipay': 'alipay',
        'wechat': 'wechat',
        'unionpay': 'credit-pay',
        'bank': 'balance-pay',
        '1': 'balance-pay',  // 余额
        '11': 'wechat',      // 51微信
        '13': 'alipay',      // 新支付宝
        '14': 'alipay'       // 51支付宝
      }
      return iconMap[payType] || 'balance-pay'
    }

    onMounted(() => {
      getChannels()
    })

    return {
      channels,
      selectedChannel,
      availableChannels,
      loading,
      selectChannel,
      getChannelIcon
    }
  }
}
</script>

<style scoped>
.payment-channel {
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  margin: 16px 0;
}

.channel-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 16px;
}

.channel-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.channel-item {
  display: flex;
  align-items: center;
  padding: 12px;
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.channel-item:hover {
  border-color: #07c160;
  background-color: #f8fff8;
}

.channel-item.selected {
  border-color: #07c160;
  background-color: #f0f9ff;
}

.channel-item.disabled {
  opacity: 0.5;
  cursor: not-allowed;
  background-color: #f5f5f5;
}

.channel-icon {
  width: 40px;
  height: 40px;
  margin-right: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1989fa;
}

.channel-info {
  flex: 1;
}

.channel-name {
  font-size: 14px;
  font-weight: 500;
  color: #333;
  margin-bottom: 4px;
}

.channel-desc {
  font-size: 12px;
  color: #999;
}

.channel-status {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
